module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.b52fac2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Bold.woff2
// module id = nw71
// module chunks = 0